import { CommonModule } from '@angular/common';
import { Component, input, model } from '@angular/core';
import { Checkbox, ICheckboxOption } from './checkbox/checkbox.component';

@Component({
  selector: 'app-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  imports: [CommonModule, Checkbox],
})
export class CheckboxGroup {
  options = input<ICheckboxOption[]>([]);
  value = model<ICheckboxOption[] | any[]>([]);

  /**
   * @name handleSelect
   * @description Handles the selection of a checkbox option.
   * @param {ICheckboxOption} option
   * @param {Event} ev
   * @returns {void}
   */
  handleSelect(option: ICheckboxOption, ev?: Event): void {
    ev?.preventDefault();
    ev?.stopPropagation();

    const currentValues = this.value() || [];
    const exists = currentValues.some((v) => v.value === option.value);
    const nextValues = exists
      ? currentValues.filter((v) => v.value !== option.value)
      : [...currentValues, option];
    const uniqueValues = nextValues.filter(
      (v, i, arr) => arr.findIndex((x) => x.value === v.value) === i,
    );

    this.value.set(uniqueValues);
  }
}
